import '@mainstage/canon/css/styles.css';
import ReactDOM from 'react-dom/client';
import App from './App';
import './components/editor/initializeMonacoEditor';
import './components/i18n/internationalization';

// Suppress the benign "ResizeObserver loop" browser warning that the webpack
// dev server overlay would otherwise display as a runtime error.
window.addEventListener('error', e => {
  if (/ResizeObserver loop/.test(e.message)) {
    e.stopImmediatePropagation();
  }
});

// Registering the service worker. Worker logic is in the public/worker.js file.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/cache_service_worker.js')
      .then(_ => {})
      .catch(_ => {});
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
